import { useMemo } from 'react'

import useGames from 'utils/hooks/queries/games/useGames'

import useOrder from '../../../components/GamesNavBar/hooks/useOrder'
import { defaultOrderFields } from './constants'
import { Filters, OrderByFields } from './types'
import { getSelectedGames } from './utils'

interface Props {
  filters: Filters
  orderByFields?: OrderByFields
}

export const useSelectedGames = ({ filters, orderByFields = defaultOrderFields }: Props) => {
  const { data: games, isPending } = useGames()
  const { order } = useOrder()

  const selectedGames = useMemo(
    () => getSelectedGames({ games: games || {}, filters, orderByFields, order }),
    [games, filters, order, orderByFields],
  )

  return { selectedGames, isPending }
}
